import React from 'react'
import styled from 'styled-components'

const Button = ({ children, selected, handleClick, isDisabled = false, accent = false, fullWidth = false, mobileText = "" }) => {

      const Tick = () => (
            <TickWrap>✔</TickWrap>
      )
      return (
            // <Wrap disabled={isDisabled} $fullWidth={fullWidth} $accent={accent} onClick={handleClick} $selected={selected}>{mobileText  ? mobileText : children}{selected && <Tick />}</Wrap>
            <Wrap disabled={isDisabled} $fullWidth={fullWidth} $accent={accent} onClick={handleClick} $selected={selected}>{children}{selected && <Tick />}</Wrap>
      )
}

export default Button

const Wrap = styled.button`
    padding: 15px 10px!important;
    min-width: ${props => (props.$fullWidth ? '100%' : '82px')};
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
      position: relative;
    font-weight: ${props => (props.$accent ? '600' : '600')};
    font-size: ${props => (props.$accent ? '12px' : '12px')};
    font-family: var(--button-font);
    text-transform: capitalize;
    border-style: solid;
    border-width: 1px;

    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')}!important;
    color: ${props => (props.disabled ? 'var(--disabled-btn-color)' : props.$accent ? 'var(--accent-btn-color)' : props.$selected ? 'var(--selected-btn-color)' : 'var(--primary-btn-color)')};
    background: ${props => (props.disabled ? 'var(--disabled-btn-bg)' : props.$accent ? 'var(--accent-btn-bg)' : props.$selected ? 'var(--selected-btn-bg)' : 'var(--primary-btn-bg)')};
    border-radius: ${props => (props.disabled ? 'var(--disabled-border-radius)' : props.$accent ? 'var(--accent-border-radius)' : props.$selected ? 'var(--selected-border-radius)' : 'var(--primary-border-radius)')};
    border-color: ${props => (props.disabled ? 'var(--disabled-border-color)' : props.$accent ? 'var(--accent-border-color)' : props.$selected ? 'var(--selected-border-color)' : 'var(--primary-border-color)')};
  
    transition: background-color .6s ease-out, color .6s ease-out, outline .6s ease-out, box-shadow .6s ease-out, border-radius .6s ease-out; 
    
 
      
      &:hover:not([disabled]) {
            color: ${props => (props.disabled ? 'var(--disabled-btn-color)' : props.$accent ? 'var(--accent-btn-color)' : props.$selected ? 'var(--selected-btn-color)' : 'var(--primary-btn-color)')};
           
            background: ${props => (props.disabled ? 'var(--disabled-btn-bg)' : props.$accent ? 'var(--accent-btn-bg-hover)' : props.$selected ? 'var(--selected-btn-bg-hover)' : 'var(--primary-btn-bg-hover)')};

            border-color: ${props => (props.disabled ? 'var(--disabled-border-color)' : props.$accent ? 'var(--accent-border-color-hover)' : props.$selected ? 'var(--selected-border-color-hover)' : 'var( --primary-border-color-hover)')};
            
      
}


@media(width > 800px) {
      padding: 15px!important;
      font-size: ${props => (props.$accent ? '14px' : '13px')};
      font-size: ${props => (props.$accent ? '14px' : '14px')};
      min-width: ${props => (props.$fullWidth ? '100%' : '110px')};
}

`

const TickWrap = styled.div`
color: inherit;
margin-left: 5px;`


